/**
 * Status-page URL helpers.
 *
 * Domain classification (isCustomDomain, isLocalDevHost, isStatusPageHost, …)
 * lives in domainUtils.js — this module only deals with URL construction and
 * navigation for the public status UI.
 */

import { isStatusPageHost, isLocalDevHost } from './domainUtils';

function normalizeOrigin(url) {
  return String(url || '').replace(/\/$/, '');
}

export function getPublicStatusPageOrigin() {
  const raw = process.env.REACT_APP_PUBLIC_STATUS_PAGE_URL;
  if (raw) return normalizeOrigin(raw);
  if (process.env.NODE_ENV !== 'production') return '';
  if (typeof window !== 'undefined' && isLocalDevHost()) return '';
  return 'https://status.midus.co';
}

export function isPublicStatusPageHost() {
  return isStatusPageHost();
}

/** Home URL for links (absolute on production subdomain, or /status in dev). */
export function getPublicStatusHomeUrl() {
  const o = getPublicStatusPageOrigin();
  if (o) return `${o}/`;
  return '/status';
}

/** Full href for manage / unsubscribe including query string. */
export function getPublicStatusHref(segment, queryString) {
  const q = queryString
    ? (queryString.startsWith('?') ? queryString : `?${queryString}`)
    : '';
  const o = getPublicStatusPageOrigin();
  if (isPublicStatusPageHost()) {
    const path = segment ? `/${segment}` : '/';
    return `${path}${q}`;
  }
  if (o) {
    const path = segment ? `/${segment}` : '/';
    return `${o}${path}${q}`;
  }
  const legacy = segment ? `/status/${segment}` : '/status';
  return `${legacy}${q}`;
}

export function navigateToStatusHome(navigate) {
  if (isPublicStatusPageHost()) {
    navigate('/');
    return;
  }
  const o = getPublicStatusPageOrigin();
  if (o) {
    window.location.href = `${o}/`;
    return;
  }
  navigate('/status');
}

/** True on /status/* (main app) or on the dedicated status subdomain. */
export function isPublicStatusBrowseContext() {
  if (typeof window === 'undefined') return false;
  if (isPublicStatusPageHost()) return true;
  return window.location.pathname.startsWith('/status');
}
